<app-header></app-header>
<bit-container>
  <h3 bitTypography="h3">{{ "invoices" | i18n }}</h3>
  <app-invoices
    [getInvoices]="getInvoices"
    [getClientInvoiceReport]="getClientInvoiceReport"
    [getClientInvoiceReportName]="getClientInvoiceReportName"
  ></app-invoices>
</bit-container>
